import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useRouter } from "../../../lib/hooks/useRouter";
import { useScrollToTop } from "../../../lib/hooks/useScrollToTop";

import { SubRouteProps } from "../../../lib/routes/routes";
import { GroupsMain } from "./GroupsMain";
import { EditGroup } from "./EditGroup";
import { AddGroup } from "./AddGroup";
import { GroupProvider } from "../../../lib/context/Groups/GroupContext";

import "./GroupsView.scss";

export const GroupsView = () => {
  useScrollToTop();
  const router = useRouter();

  const routes: SubRouteProps[] = [
    {
      exact: true,
      label: "Groups",
      to: `${router.match.url}`,
      id: "groups",
      component: GroupsMain,
    },
    {
      exact: true,
      label: "Edit Group",
      to: `${router.match.url}/edit/:id`,
      id: "edit-group",
      component: EditGroup,
    },
    {
      exact: true,
      label: "Create Group",
      to: `${router.match.url}/add-group`,
      id: "add-group",
      component: AddGroup,
    },
  ];

  return (
    <GroupProvider>
      <div className="default-page GroupsView">
        <Switch>
          {routes.map((item) => (
            <Route
              key={item.id}
              path={item.to}
              component={item.component}
              exact={item.exact ? true : undefined}
            />
          ))}
          <Redirect to={routes[0].to} />
        </Switch>
      </div>
    </GroupProvider>
  );
};
